var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-crosseling",
        size: "lg",
        "hide-footer": "",
        "hide-header": "",
        centered: "",
        title: "Přidáno do košíku"
      }
    },
    [
      _vm.lastAddedBasketItem
        ? _c("div", { staticClass: "box-popup-crosseling" }, [
            _c("div", { staticClass: "box-popup-crosseling__header" }, [
              _c(
                "svg",
                {
                  staticClass: "bi mr-3",
                  attrs: { width: "35px", height: "40px" }
                },
                [
                  _c("use", {
                    attrs: {
                      "xlink:href":
                        "/images/icons/bootstrap-icons.svg#check2-circle"
                    }
                  })
                ]
              ),
              _vm._v("\n                Zboží vloženo do košíku\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box-popup-crosseling__content" }, [
              _c("div", { staticClass: "box-popup-crosseling__product" }, [
                _c(
                  "div",
                  {
                    staticClass: "box-popup-crosseling__product__name",
                    attrs: { "data-attr": "Název" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "box-popup-crosseling__product__name--in-mobile"
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.lastAddedBasketItem.quantity) +
                            "x\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "box-popup-crosseling__product__text" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.lastAddedBasketItem.productName) +
                            "\n                        "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "box-popup-crosseling__product__image",
                    attrs: { "data-attr": "Obrázek" }
                  },
                  [
                    _c("img", {
                      staticClass: "image-product",
                      attrs: {
                        src:
                          _vm.apiBaseUrl +
                          _vm.lastAddedBasketItem.productPictureUrl,
                        alt: ""
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "box-popup-crosseling__product__unit",
                    attrs: { "data-attr": "Počet" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "box-popup-crosseling__product__name-column"
                      },
                      [
                        _vm._v(
                          "\n                            Počet\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "box-popup-crosseling__product__text" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.lastAddedBasketItem.quantity) +
                            "\n                        "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "box-popup-crosseling__product__price",
                    attrs: { "data-attr": "Cena za kus" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "box-popup-crosseling__product__name-column"
                      },
                      [
                        _vm._v(
                          "\n                            Cena za kus\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "box-popup-crosseling__product__text" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.lastAddedBasketItem.productPrice) +
                            " Kč\n                        "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "box-popup-crosseling__product__price box-popup-crosseling__product__price--main",
                    attrs: { "data-attr": "Cena celkem" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "box-popup-crosseling__product__name-column"
                      },
                      [
                        _vm._v(
                          "\n                            Cena celkem\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "box-popup-crosseling__product__text" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.lastAddedBasketItem.productPrice *
                                _vm.lastAddedBasketItem.quantity
                            ) +
                            " Kč\n                        "
                        )
                      ]
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box-popup-crosseling__footer" }, [
              _c("div", { staticClass: "box-popup-crosseling__action" }, [
                _c("div", { staticClass: "box-actions" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "box-popup-crosseling__action__btn box-popup-crosseling__action__btn--cancel btn btn-outline btn--icon-left",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$root.$emit(
                            "bv::hide::modal",
                            "modal-crosseling"
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        Pokračovat v nákupu\n                      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "box-popup-crosseling__action__btn box-popup-crosseling__action__btn--continue btn btn-primary",
                      attrs: { href: "/cart" }
                    },
                    [_vm._v("Přejít do košíku")]
                  )
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }